// extracted by mini-css-extract-plugin
export default {"detailContainer":"detail_detailContainer__yxlhw","title":"detail_title__APdW-","content":"detail_content__Vt6vq"};